/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/home/desktop/spotlightContent.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'home/desktop/spotlightContent', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



const Selectors = {
    CONTAINER: '.js-spotlightContent'
}


const Styles = {
    HIDE: 'hide'
}
function onDone(res) {
    if (!res || !res.markup) {
        return;
    }
    const $container = $(Selectors.CONTAINER);
    $container.append(res.markup);
    $container.removeClass(Styles.HIDE);
}
function onFail(err) {
    debugLog.warn('homeSpotlightContent API Fail', err);
}
function init() {
    xhr.ajax({
        method: 'GET',
        url: links.napiHomeSpotlightContent(),
    })
        .done(onDone)
        .fail(onFail);
}
export default {
    init
};
